import useQueryParams from '@common/src/hooks/useQueryParams';
import FlowProductsSidebar from '@flows/src/components/flow-products/FlowProductsSidebar';
import { useYellowhiveQuotesWithPolling } from '@flows/src/hooks/flow-products/useYellowhiveQuotesWithPolling';
import YellowhiveFlowProductsSideBarBasketPriceSummary from '@flows/src/components/flow-products/YellowhiveFlowProductsSideBarBasketPriceSummary';

const YellowhiveFlowProductsSidebar = () => {
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || undefined;
  const { data } = useYellowhiveQuotesWithPolling({
    sessionId,
    enabled: !!sessionId,
  });
  const isBasketPage = window.location.pathname.includes('basket');

  const sideBarItems = data?.navigationMap || [];

  return (
    <FlowProductsSidebar
      items={sideBarItems}
      isHidden={window.location.pathname.includes('selection-overview')}
      cartComponent={
        isBasketPage ? (
          <YellowhiveFlowProductsSideBarBasketPriceSummary />
        ) : null
      }
      basketItemsComponent={null}
    />
  );
};

export default YellowhiveFlowProductsSidebar;
